module.exports = __webpack_public_path__ + "img/pink.b496a157.webp";